<template>
	<div :class="$style.topbar">
		<div class="mr-2">
			<deal-search placement="bottomLeft" @select="goToDeal" />
		</div>


		<!-- <div class="mr-auto d-none d-md-block">
			<air-issues-history />
		</div> -->
		<!-- <div class="mr-4 d-none d-sm-block">
			<air-language-switcher />
		</div> -->
		<div class="d-none d-sm-block mr-2">
			<a-button type="primary" ghost @click="$router.push({name: 'postAdd'})">
				<a-icon type="plus" /> Nuevo post
			</a-button>
		</div>
		<div class="d-none d-sm-block" :class="$style.usersOnline">
			<router-link v-for="u in usersOnline" :key="u.id" :to="{name: 'user', params: {id: u.id}}" target="_blank" :class="$style.user">
				<a-tooltip placement="bottom">
					<template #title>
						<span>{{ u.username }}</span>
					</template>

					<a-avatar shape="circle" :src="images().avatar(u)" style="border: 1px solid #161537;" @error="onAvatarError">
						<template #icon>
							<a-icon type="user" />
						</template>
					</a-avatar>
				</a-tooltip>
			</router-link>
		</div>

		<div class="mr-auto" />

		<div class="mr-4 d-none d-sm-block">
			<a-tooltip placement="bottom">
				<template #title>
					<span>Estado de la sonda</span>
				</template>
				<a-tag :color="socketConnected ? $colors.success : $colors.danger">
					<fa-icon icon="radar" class="mr-1" :spin="socketConnected" /> {{ socketConnected ? 'Conectado' : 'Desconectado' }}
				</a-tag>
			</a-tooltip>
		</div>
		<div class="mr-4 d-none d-sm-block">
			<a-tag color="blue">
				<a-icon type="dashboard" class="mr-1" /> {{ $vars.version }}
			</a-tag>
		</div>
		<div class>
			<air-user-menu />
		</div>
	</div>
</template>

<script>
import { mapState } from 'vuex';

import AirUserMenu from '@/components/layout/TopBar/UserMenu';
// import AirActions from '@/components/layout/TopBar/Actions';
// import AirIssuesHistory from '@/components/layout/TopBar/IssuesHistory';
// import AirLanguageSwitcher from '@/components/layout/TopBar/LanguageSwitcher';

export default {
	components: {
		AirUserMenu,
	},
	computed: {
		...mapState(['settings']),
		socketConnected() {
			return this.$store.getters['socket/connected'];
		},
		usersOnline() {
			return this.$store.getters['socket/usersOnline'];
		},
		lockedPosts() {
			return this.$store.getters['socket/lockedPosts'];
		},
	},
	methods: {
		onAvatarError(e) { if (e && e.target) e.target.src = require('../../../assets/img/placeholder/avatar.jpg'); return false; },
		goToDeal(deal) {
			this.$router.push({ name: 'post', params: { id: deal.id } });
		},
	},
};
</script>

<style lang="scss" module>
	@import "./style.module.scss";
</style>
